import styled from 'styled-components';

const Container = styled.main`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TxDetails = styled.small`
  cursor: pointer;
  white-space: pre-line;
  font-size: 15px;
  border-top: 1px solid #ffffff47;
  padding-top: 8px;
  margin-top: 10px;
  display: block;
`;

const CopyIcon = styled.img`
  margin-left: 6px;
  margin-bottom: 4px;
  width: 16px;
`;

export const S = { Container, TxDetails, CopyIcon };
